var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.680594 1.03838C0.339175 1.40856 0.136719 1.98049 0.136719 2.72435V29.2735C0.136719 30.0173 0.339175 30.591 0.680594 30.9595L0.768094 31.0454L15.312 16.1752V15.9998V15.8243L0.766381 0.950661L0.680594 1.03838Z",
    fill: "url(#paint0_linear_2568_51795)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1593 21.1352L15.3125 16.1755V16.0001V15.8247L20.1609 10.8668L20.2708 10.9299L26.0149 14.2668C27.6551 15.2194 27.6551 16.779 26.0149 17.7334L20.2708 21.0703L20.1593 21.1352Z",
    fill: "url(#paint1_linear_2568_51795)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2718 21.0701L15.3134 16L0.682007 30.9614C1.22245 31.5474 2.11632 31.6193 3.12171 31.0351L20.2718 21.0701Z",
    fill: "url(#paint2_linear_2568_51795)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2718 10.9298L3.12171 0.964931C2.11632 0.380721 1.22245 0.452653 0.682007 1.03862L15.3134 16L20.2718 10.9298Z",
    fill: "url(#paint3_linear_2568_51795)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.1619 20.9597L3.12171 30.8597C2.16779 31.4141 1.31681 31.3773 0.769507 30.872L0.682007 30.9615L0.769507 31.0475C1.31681 31.5509 2.16779 31.5896 3.12171 31.0352L20.2718 21.0703L20.1619 20.9597Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.680594 30.7863C0.339175 30.4161 0.136719 29.8424 0.136719 29.1003V29.2757C0.136719 30.0197 0.339175 30.5933 0.680594 30.9617L0.768094 30.8723L0.680594 30.7863Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M26.0143 17.5578L20.1604 20.9595L20.2702 21.0718L26.0143 17.735C26.8344 17.2577 27.2445 16.6297 27.2445 16.0016C27.1758 16.5683 26.7572 17.1262 26.0143 17.5578Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M3.1203 1.14047L26.0144 14.4422C26.759 14.8738 27.1759 15.4317 27.2446 16.0001C27.2446 15.3721 26.8345 14.744 26.0144 14.2668L3.1203 0.965037C1.47839 0.012405 0.136719 0.803631 0.136719 2.72644V2.90188C0.136719 0.979075 1.47839 0.187841 3.1203 1.14047Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2568_51795",
    x1: 14.0217,
    y1: 2.44499,
    x2: -6.12012,
    y2: 22.1425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2568_51795",
    x1: 28.1506,
    y1: 16.0005,
    x2: -0.256341,
    y2: 16.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2568_51795",
    x1: 17.5769,
    y1: 18.7552,
    x2: -9.73697,
    y2: 45.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2568_51795",
    x1: -3.00267,
    y1: -7.79898,
    x2: 9.19404,
    y2: 4.12872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.045442bd9036e181b4738d5c85555184.svg";
export { ForwardRef as ReactComponent };